"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_1 = require("@mui/material/styles");
var Box_1 = __importDefault(require("@mui/material/Box"));
var Button_1 = __importDefault(require("@mui/material/Button"));
var Dialog_1 = __importDefault(require("@mui/material/Dialog"));
var DialogActions_1 = __importDefault(require("@mui/material/DialogActions"));
var DialogContent_1 = __importDefault(require("@mui/material/DialogContent"));
var DialogTitle_1 = __importDefault(require("@mui/material/DialogTitle"));
var makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
var classnames_1 = __importDefault(require("classnames"));
var useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
var react_intl_1 = require("react-intl");
var useStyles = (0, makeStyles_1.default)(function (theme) { return ({
    dialogContainer: {
        maxWidth: '100%',
        width: '100%',
        alignSelf: 'end',
        borderRadius: 0,
        margin: 0,
    },
    contentContainer: {
        minWidth: 600,
        paddingTop: 12,
        paddingBottom: 24,
    },
    title: {
        position: 'relative',
        fontSize: 32,
        fontWeight: 'bold',
        '&::after': {
            content: '""',
            position: 'absolute',
            left: 24,
            width: 120,
            bottom: 8,
            height: 6,
            backgroundColor: theme.palette.primary.main,
        },
    },
    textContainer: {
        maxHeight: 300,
        paddingBottom: 0,
        marginTop: 16,
        marginBottom: 24,
    },
    buttonContainer: {
        paddingLeft: 24,
        paddingRight: 24,
        '& > :not(:first-of-type)': {
            marginLeft: 32,
        },
    },
    buttonAction: {
        flex: 1,
    },
    buttonAccept: {
        borderRadius: 4,
    },
}); });
var CookieConsentDialog = function (_a) {
    var show = _a.show, onClose = _a.onClose;
    var classes = useStyles();
    var _b = (0, react_1.useState)(false), showDetails = _b[0], setShowDetails = _b[1];
    (0, react_1.useEffect)(function () {
        if (show) {
            setShowDetails(false);
        }
    }, [show]);
    var onAccept = function () {
        onClose('ACCEPTED');
    };
    var onReject = function () {
        onClose('REJECTED');
    };
    var onDetails = function () {
        setShowDetails(true);
    };
    var theme = (0, styles_1.useTheme)();
    var fullWidth = (0, useMediaQuery_1.default)(theme.breakpoints.down('md'));
    var intl = (0, react_intl_1.useIntl)();
    var title = intl.formatMessage({ id: 'cookie-consent.title' });
    var longText = intl.formatMessage({ id: 'cookie-consent.long-text' });
    var shortText = intl.formatMessage({ id: 'cookie-consent.short-text' });
    return (react_1.default.createElement(Dialog_1.default, { open: show, fullWidth: fullWidth, classes: { paperFullWidth: classes.dialogContainer } },
        react_1.default.createElement(Box_1.default, { className: classes.contentContainer },
            react_1.default.createElement(DialogTitle_1.default, { className: classes.title }, title),
            react_1.default.createElement(DialogContent_1.default, { className: classes.textContainer },
                react_1.default.createElement("div", { dangerouslySetInnerHTML: {
                        __html: showDetails ? longText : shortText,
                    } })),
            react_1.default.createElement(DialogActions_1.default, { classes: { spacing: classes.buttonContainer } },
                showDetails ? (react_1.default.createElement(Button_1.default, { variant: "outlined", className: classes.buttonAction, onClick: onReject },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "reject" }))) : (react_1.default.createElement(Button_1.default, { variant: "outlined", className: classes.buttonAction, onClick: onDetails },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "details" }))),
                react_1.default.createElement(Button_1.default, { variant: "contained", className: (0, classnames_1.default)(classes.buttonAction, classes.buttonAccept), onClick: onAccept },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "accept" }))))));
};
exports.default = CookieConsentDialog;
